import { Module } from '../Module';

Module.instance().directive('tbDisableSelection', <any[]>[
  () => {
    return {
      restrict: 'C',
      link: (scope: ng.IScope, element: JQuery) => {
        if (navigator.userAgent.match(/msie/i)) {
          element.on('selectstart dragstart', (event: JQuery.Event) => {
            const selectionParent = $(event.target).closest('.tb-enable-selection, .tb-disable-selection');
            if (!selectionParent.hasClass('tb-enable-selection')) {
              event.preventDefault();
            }
          });
        }
      }
    };
  }
]);
